import React from 'react'
import Users from '../Components/Users/Users'

const UsersPage = () => {
  return (
    <div>
      <Users/>
    </div>
  )
}

export default UsersPage
